import React from "react"
import { Link } from "react-router"
import { ILinkProps, StyleVariants } from "../../state/sharedTypes"


interface IProps {
  className?: string
  variant?: string
  href?: string
  linkProps?: ILinkProps
  targetBlank?: boolean
  children: React.ReactNode
  action?: () => void
}

const TextLink: React.FC<IProps> = ({
  variant = StyleVariants.BLUE,
  targetBlank = false,
  className,
  href,
  linkProps,
  children,
  action
}: IProps): JSX.Element => {

  const defaultClasses = [
    `text-${variant}-500`,
    `hover:text-${variant}-600`,
  ]
  const propClasses = className ? className.split(" ") : []
  const allClasses = [...defaultClasses, ...propClasses].join(" ")

  if (href && targetBlank)
    return (
      <a {...linkProps} href={href} className={allClasses} target="_blank" rel="noreferrer">
        {children}
      </a>
    )

  if (href)
    return (
      <Link {...linkProps} to={href} className={allClasses}>
        {children}
      </Link>
    )

  if (action)
    return (
      <button type="button" onClick={action} className={allClasses}>
        {children}
      </button>
    )

  return (
    <button type="submit" className={allClasses}>
      {children}
    </button>
  )
}

export default TextLink
